import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ExploreDeepWaters from "./sections/ExploreDeepWaters";
import ImpactByTheNumbers from "./sections/ImpactByTheNumbers";
import TherapeutischeSchwerpunkte from "./sections/TherapeutischeSchwerpunkte";
import CloudSecurityIntegration from "./sections/CloudSecurityIntegration";
import ClientSuccessStories from "./sections/ClientSuccessStories";
import SupportTheHeritage from "./sections/SupportTheHeritage";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ExploreDeepWaters />
      <ImpactByTheNumbers />
      <TherapeutischeSchwerpunkte />
      <CloudSecurityIntegration />
      <ClientSuccessStories />
      <SupportTheHeritage />
      <Footer />
    </div>;
}